import { Pipe, PipeTransform } from "@angular/core";
import { ProductRequestStatus } from "../enums/product-request-status";
import { prettifyProductRequestStatus } from "../helpers/prettify-product-request-status";

@Pipe({name: 'prettifyProductRequestStatus'})
export class PrettifyProductRequestStatusPipe implements PipeTransform {
  transform(value: ProductRequestStatus): string {
    return prettifyProductRequestStatus(value);
  }
}